import useStore from "@/store";
import { Button } from "@/ui/Button";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsInfoLg } from "react-icons/bs";
import PaymentPercentagePopover from "./PaymentPercentagePopover";
import PercentageBadge from "./PercentageBadge";

const UserPaymentPercentage = () => {
  const { t } = useTranslation("stats");
  const userPayment = useStore(state => state.userPayment);
  const setFreezeAccountDelay = useStore(state => state.setFreezeAccountDelay);
  const {
    percentage,
    debtOfWeek,
    paymentAmount,
    dayOfWeek,
    frozenHour,
    requiredPercentage,
    frozenEnabled,
  } = userPayment || {};

  useEffect(() => {
    if (percentage != null && percentage < requiredPercentage && frozenEnabled) {
      const todayIndex = new Date().getDay();
      const targetIndex = dayOfWeek % 7;

      const now = dayjs();
      const targetDate = dayjs()
        .add(
          targetIndex >= todayIndex
            ? targetIndex - todayIndex
            : 7 - (todayIndex - targetIndex),
          "day"
        )
        .hour(frozenHour ?? 18)
        .minute(0)
        .second(0)
        .millisecond(0);

      // Calculate difference in hours
      const diffInHours = targetDate.diff(now, "hour");
      const delayInSeconds = targetDate.diff(now, "seconds");

      // If it's within the next 24 hours (and in the future), set the delay
      if (
        (diffInHours > 0 && diffInHours < 24) ||
        (diffInHours === 0 && delayInSeconds > 0)
      ) {
        setFreezeAccountDelay(delayInSeconds);
      } else {
        setFreezeAccountDelay(null);
      }
    } else {
      setFreezeAccountDelay(null);
    }
  }, [
    percentage,
    debtOfWeek,
    paymentAmount,
    dayOfWeek,
    setFreezeAccountDelay,
    frozenHour,
    requiredPercentage,
    frozenEnabled,
  ]);

  return (
    <div className="flex items-center">
      <PercentageBadge
        percentage={percentage}
        requiredPercentage={requiredPercentage}
      />
      <span className="font-semibold text-sm whitespace-nowrap text-muted-foreground flex items-center">
        &nbsp; {t("popovers.debt_info.paid_status")}
      </span>

      <PaymentPercentagePopover
        popoverTriggerProps={{
          asChild: true,
        }}
        paymentPercentage={userPayment}
        trigger={
          <Button
            size="icon"
            variant="outline"
            className="h-7 w-7 rounded-full ms-2"
            onClick={e => e.stopPropagation()}
          >
            <BsInfoLg className="text-[1rem]" />
          </Button>
        }
      />
    </div>
  );
};

export default UserPaymentPercentage;
